export function formatProjectItems(data) {
  return data.lsProyects;
}
